/**
 * @file   
 * @create macaiqi 2025/06/12
 * @update 
 */
import React from 'react';
import './index.scss'

export default function Footer() {
    return (
        <div className='footer'>
            <p>版权所有：重庆中国三峡博物馆 渝ICP备 05005919号
            </p>
            {!window.isWap && <p>地址：重庆市渝中区人民路236号 邮编：400015 E-mail:3gMuseum@163.com</p>}
        </div>
    )
}
